import { configureStore } from "@reduxjs/toolkit";
import jobsReducer from "./jobsSlice";
import configReducer from "./configSlice";

export const store = configureStore({
  reducer: { jobs: jobsReducer, configs: configReducer },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: true }),
});
